"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NewBannerText = require("./NewBannerText");
Object.keys(_NewBannerText).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewBannerText[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewBannerText[key];
    }
  });
});